module.exports = __webpack_public_path__ + "6da66396a441e5698d0067a10c1ed2fe.svg";